import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import ChequesIndex from '../../../components/cheques'
import './style.scss'
const ChequesPages = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <ChequesIndex
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default ChequesPages
/* ChequesIndex */